/**
 * Navigation Highlights Hover Effect
 * Handles dimming effect on hover for navigation highlights mosaic
 * Provides Safari compatibility for :has() selector issues
 */
export default function navigationHighlightsHover() {
  return {
    init() {
      this.$nextTick(() => {
        const list = this.$el;
        if (!list) return;

        const items = Array.from(list.querySelectorAll("li"));
        if (items.length === 0) return;

        const resetOpacity = () => {
          items.forEach((item) => {
            const dimElement = item.querySelector(".dim");
            if (dimElement) {
              dimElement.style.opacity = "";
            }
          });
        };

        const handleMouseEnter = (hoveredItem) => {
          items.forEach((item) => {
            if (item !== hoveredItem) {
              const dimElement = item.querySelector(".dim");
              if (dimElement) {
                dimElement.style.opacity = "0.4";
              }
            }
          });
        };

        const handleMouseLeave = () => {
          resetOpacity();
        };

        // Attach event listeners to each item
        items.forEach((item) => {
          item.addEventListener("mouseenter", () => handleMouseEnter(item));
          item.addEventListener("mouseleave", handleMouseLeave);
        });

        // Also handle when mouse leaves the entire list
        list.addEventListener("mouseleave", resetOpacity);
      });
    }
  };
}
